import React, { Component } from 'react';
import Slider from 'react-slick';
import './styles.scss';
import { resolvePublicAssets } from '../../../../utils';
import { goto } from '../../../../actions/historyActions';
import { windowSize } from '../../../../utils/window';
import { WINDOW_SIZE } from '../../../../constants/constants';

interface OfferDetailBannerProps {
  offerDetailBanner: {
    imgPath?: string;
    title?: string;
    desc?: Object;
    isNotClickableBanner?: boolean;
  };
}
interface OfferDetailBannerState {
  windowSize?: number;
}

export default class OfferDetailBanner extends Component<
  OfferDetailBannerProps,
  OfferDetailBannerState
> {
  constructor(props: OfferDetailBannerProps) {
    super(props);
    this.state = {
      windowSize: WINDOW_SIZE.LARGE,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowSize);
    this.updateWindowSize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowSize);
  }

  updateWindowSize = () => {
    this.setState({
      windowSize: windowSize(),
    });
  };

  render() {
    const { offerDetailBanner } = this.props;
    const offercardbanner =
      this.state.windowSize === WINDOW_SIZE.SMALL
        ? resolvePublicAssets(
            `/assets/images/offers/offer-detail-banner-mobile@3x.png`,
          )
        : resolvePublicAssets(
            `/assets/images/offers/offercard-2-desktop@3x.png`,
          );
    const link = `emma-my-privileges/details-view?myprivileges_details_id=vaccination`;
    return (
      <div className="emma-offer-detail-banner">
        <div
          onClick={() => {
            if (!offerDetailBanner || !offerDetailBanner.isNotClickableBanner)
              goto(link);
          }}
          data-enable-ga
          data-ga-type="button"
        >
          <div
            className="emma-offer-detail-banner__inner"
            style={{ backgroundImage: `url(${offercardbanner})` }}
          >
            <div className="emma-offer-detail-banner__inner_banner_content">
              <div className="emma-offer-detail-banner__inner_banner_content_title">
                {offerDetailBanner && offerDetailBanner.title}
              </div>
              <div className="emma-offer-detail-banner__inner_banner_content_desc">
                {offerDetailBanner && offerDetailBanner.desc}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
